import React from 'react';
import { useSelector } from 'react-redux';
import ScansList from './ScansList';

function OrderTracker({title}) {
    // const dispatch = useDispatch();

    const orderDetails = useSelector((state) => state.orderDetails.orderDetails.orderDetails);

    // const handleButtonClick = () => {
    //     dispatch(setModal('tracking'));
    // }

    const hasTrackingId = orderDetails && orderDetails.waybill;
    const hasOrderDetails = Object.keys(orderDetails || {}).length > 0;

    return (
        <div 
            className='border border-[#EAEAEA] rounded-lg px-4 py-3 flex flex-col gap-3'
            role="region" 
            aria-labelledby="order-timeline"
        >
            <div className="flex items-center justify-between">
                <h1 
                    id="order-timeline" 
                    className='font-semibold text-base text-[#666666] select-none'
                >
                    {title}
                </h1>

                {/* <button 
                    onClick={handleButtonClick} 
                    className="hover:underline select-none outline-none font-medium text-[14px] leading-[22px] text-[#1055EB] focus:ring-2 focus:ring-[#1055EB] focus:ring-opacity-20 rounded px-1 py-1"
                    aria-label="Add or replace tracking ID"
                >
                    Add/Replace ID
                </button> */}
            </div>

            <div className="flex flex-col gap-[22px]">
                {hasOrderDetails && hasTrackingId && (
                    <div 
                        className="flex flex-col gap-2 text-[#121212] select-none"
                        role="group"
                        aria-labelledby="tracking-info"
                    >
                        <h2 
                            id="tracking-info" 
                            className='font-semibold text-base'
                        >
                            Delhivery
                        </h2>
                        <p className='font-medium text-[14px] leading-6'>
                            <span className="text-gray-600">Tracking ID: </span>
                            <span className="font-mono">{orderDetails.waybill}</span>
                        </p>
                    </div>
                )}

                <div role="application" aria-label="Order tracking timeline">
                    <ScansList />
                </div>
            </div>
        </div>
    );
}

export default React.memo(OrderTracker);
